import 'react-phone-input-2/lib/style.css';

import { Button, Input, Tooltip, Typography } from '@smartgift/frontend-toolkit';
import { useFormik } from 'formik';
import PropTypes from 'prop-types';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { MAX_EMAIL_LENGTH, MAX_FIRST_NAME_LENGTH, MAX_LAST_NAME_LENGTH } from '@hero/constants';
import { PasswordInput } from '@hero/molecules';
import { getInviteInfoSchema } from '@hero/validations';

import * as S from './style';

const InviteInfoForm = ({ initialValues, organizationName, primaryButton, onSubmit }) => {
  const { t } = useTranslation();

  const formik = useFormik({
    initialValues: {
      firstName: initialValues?.firstName ?? '',
      lastName: initialValues?.lastName ?? '',
      email: initialValues?.email ?? '',
      password: initialValues?.password ?? '',
      confirmPassword: initialValues?.confirmPassword ?? ''
    },
    validationSchema: getInviteInfoSchema(),
    enableReinitialize: true,
    onSubmit: data => {
      onSubmit(data);
    }
  });

  return (
    <S.InviteInfoForm>
      <S.InviteInfoFormHeader>
        <Typography variant="h1">{t('welcome')}!</Typography>
        <Typography>
          <Trans
            i18nKey="InviteFinish.title"
            components={{
              b: <b />
            }}
            values={{ organizationName }}
          />
        </Typography>
      </S.InviteInfoFormHeader>

      <S.InviteInfoFormGroups>
        <Typography variant="subtitle3Bold" style={{ marginBottom: 8, marginRight: 'auto' }}>
          {t('contactInformation')}
        </Typography>

        <S.InviteInfoFormGroup>
          <Input
            label={`${t('firstName')}*`}
            name="firstName"
            onChange={formik.handleChange}
            variant="outlined"
            value={formik.values.firstName}
            helperText={formik.touched.firstName && formik.errors.firstName}
            error={formik.touched.firstName && formik.errors.firstName}
            inputProps={{ maxLength: MAX_FIRST_NAME_LENGTH }}
          />
          <Input
            label={`${t('lastName')}*`}
            name="lastName"
            onChange={formik.handleChange}
            variant="outlined"
            value={formik.values.lastName}
            helperText={formik.touched.lastName && formik.errors.lastName}
            error={formik.touched.lastName && formik.errors.lastName}
            inputProps={{ maxLength: MAX_LAST_NAME_LENGTH }}
          />
        </S.InviteInfoFormGroup>

        <Tooltip content={t('emailAlreadyVerified')} tooltipConfig={{ placement: 'top' }}>
          <Input
            label={`${t('email')}`}
            name="email"
            variant="outlined"
            value={formik.values.email}
            inputProps={{ maxLength: MAX_EMAIL_LENGTH }}
            disabled
          />
        </Tooltip>

        <PasswordInput
          showPasswordBox
          name="password"
          onChange={formik.handleChange}
          value={formik.values.password}
          hasError={formik.touched.password && formik.errors.password}
        />
        <PasswordInput
          name="confirmPassword"
          placeholder="confirmPassword"
          onChange={formik.handleChange}
          value={formik.values.confirmPassword}
          hasError={formik.touched.confirmPassword && formik.errors.confirmPassword}
          helperText={formik.touched.confirmPassword && formik.errors.confirmPassword}
        />

        <Button color="primary" onClick={formik.handleSubmit} block {...primaryButton}>
          {primaryButton?.children || t('continue')}
        </Button>
      </S.InviteInfoFormGroups>
    </S.InviteInfoForm>
  );
};

export { InviteInfoForm };

InviteInfoForm.propTypes = {
  initialValues: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    email: PropTypes.string,
    password: PropTypes.string,
    confirmPassword: PropTypes.string
  }),
  organizationName: PropTypes.string,
  onSubmit: PropTypes.func,
  primaryButton: PropTypes.shape({
    children: PropTypes.string
  })
};
